import { all, takeEvery, put, select, call } from "redux-saga/effects";
import { initialize } from "redux-form";
import UsersService from "../services/users";
import Http from '../commons/utils/Http'
import jwt from "jsonwebtoken";

import { setUserData } from "../store/actions/userLoginActions";

function callUpdateUser(body) {
    if (body.birth_date === "") {
        body.birth_date = null;
    } else {
        body.birth_date = formatDateTimestamp(body.birth_date);
    }
    return UsersService.update(body);
}

function callTokenExchange(token) {
    return Http.get(`/token-xchange?application_id=${2}&token=${token}`)
}

function formatDateTimestamp(data) {
  
    if(data){

        let day = data.substring(0, 2);
        let month = data.substring(2, 4);
        let year = data.substring(4, 8);
        let dateFormat = year + '-' + ("0" + month).slice(-2) + '-' + ("0" + day).slice(-2);
        return new Date(dateFormat);
    }

}

function* handleInitForm() {
    const state = yield select();
    var birthDate=formatDateInit(state.userLogin.userData.birth_date);
    var developer=getCurrentDeveloperStatus(state.userLogin.userData.developer)
    const editUserForm = {
        id: state.userLogin.userData.id,
        first_name: state.userLogin.userData.first_name,
        last_name: state.userLogin.userData.last_name,
        birth_date: birthDate,
        phone: state.userLogin.userData.phone,
        developer: developer 
    }
    yield put(initialize('editUserData', editUserForm));
}

function getCurrentDeveloperStatus(developer){
    if (developer){
        return "sim"
    } else return "nao";
}

function formatDateInit(birthDate) {
    if (birthDate) {
        let str = birthDate.split(" ")[0].split("-")
        return str[2] + str[1] + str[0]
    }
}

function* handleSaveUser(action) {
    const response = yield call(callUpdateUser, action.payload);
    if (!response.data.response.error) {
        let token = localStorage.getItem("token");
        const responseExchange = yield call(callTokenExchange, token);
        if (!responseExchange.data.response.error) {
            const token = responseExchange.data.data.access_token
            const tokenData = jwt.decode(token);

            localStorage.setItem('token', token);
            yield put(setUserData(tokenData));
        }
    }
}

export function* watchDadosUsuarioActions() {
    yield all([
        takeEvery("INIT_DADOS_USUARIO_FORM", handleInitForm),
        takeEvery("SAVE_USER_DATA", handleSaveUser)
    ])
}
